import { fmtDate } from '@/lib/format'
import { coachReviewStatus } from './labels'
import type { CoachReview } from './types'
import { EvidencePicker } from './EvidencePicker'

/** Conversation switching never starts or changes a review. */
export function ReviewPicker({
  previous,
  value,
  onChange,
}: {
  previous: CoachReview[]
  value: string
  onChange: (value: string) => void
}) {
  const options = [
    { value: '', label: 'Current review', detail: '' },
    ...previous.map((review, index) => ({
      value: review.review_id,
      label: `Review ${previous.length - index}`,
      detail: `${fmtDate(review.created_at)} · ${coachReviewStatus[review.status] ?? review.status}`,
    })),
  ]
  return (
    <EvidencePicker options={options} value={value} onChange={onChange} label="Review conversation" />
  )
}
